export default __webpack_public_path__ + "static/media/partner-8-bigtime.57c85b54.png";